import {
  INIT_DATA,
  SET_EDITTABLE_HEIGHT,
  UPDATE_DATA,
  UPDATE_READ_ONLY,
  SET_COLHEADERS,
  SET_HIDDEN_COLUMNS,
  UPDATE_COLUMNS_WIDTH,
  SET_CELL,
  SET_COLUMNS,
  SET_FIND_ALL_SELECT_ROW_COL,
  SET_readOnly,
} from '../actions/types';

import Handsontable from 'handsontable';

var CustomTextEditor = Handsontable.editors.TextEditor.prototype.extend();

const initialState = {
  data: null,

  manualColumnResize: true,
  outsideClickDeselects: false,
  fillHandle: false,
  undo: true,
  rowHeaders: true,
  readOnly: true,
  colHeaders: ['In TC', 'Out TC', 'Dur', 'Memo', 'Target', 'Char', 'Pos'],
  height: 600,
  editor: CustomTextEditor,
  // hiddenColumns:{
  //     columns: [ 2,4,7,8,10,13,14],
  //     indicators: true
  // },
  colWidths: [85, 85, 80, 80, 310, 50, 50],
  // rowHeights:59, // 单元格高
  columns: [
    { data: 'In', renderer: 'html' },
    { data: 'Out', renderer: 'html' },
    //{data: "ShotChangeTitle", renderer: "html"},
    { data: 'DurationTitle', renderer: 'html', editor: false },
    {
      data: 'Memo',
      renderer: function (instance, td, row, col, prop, value, cellProperties) {
        td.innerHTML =
          "<div class='memoWrap'><div class='memo'>" + value + '</div></div>';
        return td;
      },
    },
    { data: 'SubtitleCaption' },
    { data: 'Length', renderer: 'html', editor: false },
    { data: 'Position', renderer: 'html' },
  ],
  cell: [],
  selectStart: 0, //藍框的index,

  findAllSelectRowCol: 0, //目標位置
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_readOnly:
      return {
        ...state,
        readOnly: action.payload,
      };

    case SET_COLUMNS:
      return {
        ...state,
        columns: action.payload,
      };

    //設定字元的對其
    case SET_CELL:
      return {
        ...state,
        cell: action.payload,
      };

    case SET_FIND_ALL_SELECT_ROW_COL:
      return {
        ...state,
        findAllSelectRowCol: action.payload,
      };

    //更新寬度
    case UPDATE_COLUMNS_WIDTH:
      return {
        ...state,
        colWidths: action.payload,
      };
    //顯示或隱藏
    case SET_HIDDEN_COLUMNS:
      return {
        ...state,
        hiddenColumns: action.payload,
      };
    case INIT_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case UPDATE_DATA:
      const newData = state.data.slice(0);

      for (let [row, column, oldValue, newValue] of action.payload) {
        newData[row][column] = newValue;
      }

      return {
        ...state,
        data: newData,
      };

    case UPDATE_READ_ONLY:
      return {
        ...state,
        readOnly: action.payload,
      };
    case SET_EDITTABLE_HEIGHT:
      return {
        ...state,
        height: action.payload,
      };

    case SET_COLHEADERS:
      return {
        ...state,
        colHeaders: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EditTableReducer.js